module.exports = __webpack_public_path__ + "img/sec2_1.c2805f95.png";